import type { ITelemetryItem } from '@microsoft/applicationinsights-core-js';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import type { OidcAccessToken } from '@ori/auth';

interface AppInsightsExceptionData {
  message?: string;
}

const telemetryInitializer = (item: ITelemetryItem): boolean => {
  if (item.baseType === 'ExceptionData' && item.baseData) {
    const exceptions: AppInsightsExceptionData[] | null | undefined = item.baseData.exceptions as
      | AppInsightsExceptionData[]
      | null
      | undefined;

    if (exceptions?.[0] && exceptions[0].message?.startsWith('Customer ID mismatch')) {
      if (!item.tags) {
        // eslint-disable-next-line no-param-reassign -- Needs to initialize empty tags
        item.tags = [];
      }
      // eslint-disable-next-line no-param-reassign -- Needs to set the modified tags
      item.tags['ai.user.id'] = '-';
    }
  }

  return true;
};

export const trackCustomerTokenMismatch = (customerId: number, token: OidcAccessToken) => {
  if (window.appInsights) {
    const tokenCustomerId = Number(token.getClaim('customer_id'));
    if (tokenCustomerId !== customerId && customerId > 0) {
      window.appInsights.addTelemetryInitializer(telemetryInitializer);
      window.appInsights.trackException({
        exception: new Error(
          `Customer ID mismatch, app ID: ${customerId}, token ID: ${tokenCustomerId}`,
        ),
        severityLevel: SeverityLevel.Error,
      });
    }
  }
};
